import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  actions: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
});
